<template>
  <div>
    <div class="">
      <label for="nodeSize" class="form-label ed-label">Relax Nodes</label>
      {{ edgeStrengthData }}
      <input
        type="range"
        min="0"
        max="2000"
        class="form-range ed-slider"
        v-model="edgeStrengthData"
        id="nodeSize"
      />
    </div>
    <div class="">
      <label for="linkDistance" class="form-label ed-label"
        >Link Distance</label
      >
      {{ linkDistanceData }}
      <input
        type="range"
        min="0"
        max="2000"
        v-model="linkDistanceData"
        class="form-range ed-slider"
        id="linkDistance"
      />
    </div>
    <div class="">
      <label for="nodeStrength" class="form-label ed-label"
        >Node Strength</label
      >
      {{ nodeStrengthData }}
      <input
        type="range"
        min="0"
        max="2000"
        v-model="nodeStrengthData"
        class="form-range ed-slider"
        id="nodeStrength"
      />
    </div>

    <div class="">
      <label class="form-label ed-label">Choose Layout Type:</label>
      <ed-dropdown
        :selected="layoutTypeData"
        :listItems="availableLayouts"
        :isSelected="setAvailableLayouts"
      />
    </div>
  </div>
</template>

<script>
import { GraphLayoutPredict } from '@antv/vis-predict-engine';
import graphReactor from '@/graphReactor';
import graphConfig from '@/plugins/graphConfig';
import edDropdown from './ed-forms/ed-dropdown.vue';

export default {
  components: {
    edDropdown,
  },

  data() {
    return {
      // canvasHeightData: graphConfig.height,
      // canvasWidthData: graphConfig.width,
      // nodeSizeData: graphConfig.layout.nodeSize,
      linkDistanceData: graphConfig.layout.linkDistance,
      nodeStrengthData: graphConfig.layout.nodeStrength,
      layoutTypeData: graphConfig.layout.type,
      edgeStrengthData: graphConfig.layout.edgeStrength,
      rangeData: 0,
      availableLayouts: [
        'force',
        'dagre',
        'radial',
        'circular',
        'gForce',
        'fruchterman',
        'concentric',
        'mds',
        'grid',
        'predictLayout',
      ],
    };
  },

  computed: {
    getCurrentRange() {
      return this.$store.state.explore_data_range;
    },
  },

  watch: {
    rangeData(val) {
      this.$store.dispatch('setRangeValue', val);
    },
    edgeStrengthData(val) {
      console.log('configData', val);
      graphReactor.exploreInstance.updateLayout({
        edgeStrength: Number(val),
      });
    },
    linkDistanceData(val) {
      console.log('configData', val);
      graphReactor.exploreInstance.updateLayout({
        linkDistance: Number(val),
      });
    },
    nodeStrengthData(val) {
      console.log('configData', val);
      graphReactor.exploreInstance.updateLayout({
        nodeStrength: Number(val),
      });
    },
    async layoutTypeData(val) {
      console.log('configData', val);
      if (val === 'predictLayout') {
        const { predictLayout } = await GraphLayoutPredict.predict(
          graphReactor.exploreInstance.save(),
        );
        const layout = {
          type: predictLayout,
          nodeSize: 50,
          preventOverlap: true,
        };
        graphReactor.exploreInstance.updateLayout(layout);
      } else if (val === 'dagre') {
        graphReactor.exploreInstance.updateLayout({
          type: val,
          nodesep: 2,
          ranksep: 30,
          rankdir: 'LR',
          align: 'DL',
        });
      } else if (val === 'concentric') {
        graphReactor.exploreInstance.updateLayout({
          type: 'concentric',
          center: [200, 200], // The center of the graph by default
          linkDistance: 50, // The edge length
          preventOverlap: true, // nodeSize or size in data is required for preventOverlap: true
          nodeSize: 30,
          sweep: 10,
          equidistant: false,
          startAngle: 0,
          clockwise: false,
          maxLevelDiff: 10,
          sortBy: 'degree',
        });
      } else {
        graphReactor.exploreInstance.updateLayout({
          type: val,
        });
      }
    },
  },
  methods: {
    setAvailableLayouts(item) {
      this.layoutTypeData = item;
    },
  },
};
</script>

<style lang="scss">
@import '../scss/abstracts/variables';
@import '../scss/components/ed-slider';
</style>
